import React from "react";
import remoteJob from "../../images/hireDeveloper/remoteJob.jpg";
import careerGrowth from "../../images/hireDeveloper/careerGrowth.jpg";
import highPaying from "../../images/hireDeveloper/highPaying.jpg";

const RemoteTeam = () => {
  return (
    <>
      <section className="remoteTeamSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Why Join Hire <span>Remote Teams?</span>
                </h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4" data-aos="zoom-in">
              <div className="remoteBg">
                <span>1</span>
                <img src={remoteJob} alt="Hire Android Developer" />
                <div className="details">
                  <h5>Get Remote Jobs</h5>
                  <p>
                    You get to apply for the best remote jobs available globally
                    from the comfort of your home
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="zoom-in">
              <div className="remoteBg">
                <span>2</span>
                <img src={careerGrowth} alt="Remote Developer" />
                <div className="details">
                  <h5>Career Growth</h5>
                  <p>
                    Grow rapidly by working on challenging technical and
                    business problems on the latest technologies.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4" data-aos="zoom-in">
              <div className="remoteBg">
                <span>3</span>
                <img src={highPaying} alt="Hire Remote Developer" />
                <div className="details">
                  <h5>High Paying Packages</h5>
                  <p>
                    Get the best global pay scale offered by top companies
                    working around globally.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RemoteTeam;
